import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {Button2} from '../../styles/components/button.style';

export const SideBasketStyled = styled.aside`
  color: ${props => props.theme.secondaryColor};
  width: ${props => props.theme.menuPage.basket.width};
  min-width: ${props => props.theme.menuPage.basket.width};
  margin: 0 0 auto;
  z-index: 2;
  & > div {
    height: inherit;
    ${media.small`
      background-color: ${props => props.theme.sideBasket.backgroundColor};
    `};
  }

  ${media.small`
    background-color: ${props => props.theme.sideBasket.backgroundColor};
    height: ${props => props.expand ? '100%' : 'auto'};
    color: ${props => props.theme.primaryColor};
    display: ${props => props.show ? 'block' : 'none'};
    position: fixed;
    width: 100%;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: hidden;
    transform: translate3d(0px, 0px, 0px);  // force ios safari to rerender
    .sticky {
      height: ${props => props.expand ? '100%' : 'auto'};
    }
  `};
`;

export const Title = styled.div`
  background-color: ${p => p.theme.sideBasket.header.backgroundColor};
  font-size: ${props => props.theme.sideBasket.header.fontSize};
  padding: ${props => props.theme.menuPage.basket.padding};
  text-transform: uppercase;
  text-align: center;
  font-weight: normal;
  border-top: ${p => p.theme.sideBasket.header.borderTop};
  border-right: ${p => p.theme.sideBasket.header.borderRight};
  border-bottom: ${p => p.theme.sideBasket.header.borderBottom};
  color: ${p => p.theme.sideBasket.header.color};
  ${media.small`
    display: none;
  `};
`;

export const BasketContent = styled.div`
  background-color: ${props => props.theme.primaryBackground};
  ${media.small`
    background-color: ${props => props.theme.sideBasket.backgroundColor};
    height: 100%;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    max-height: 100vh;
    height: inherit;
  `};
`;

export const Message = styled.span`
  display: block;
  background-color: ${props => props.theme.primaryBackground};
  padding: ${props => props.theme.padding};
  border-right: ${p => p.theme.sideBasket.summary.borderRight};
`;

export const CheckoutButton = Button2.extend`
  background-color: ${p => p.isLoading ? p.theme.button.checkout.disabled.backgroundColor : p.theme.button.checkout.backgroundColor.desktop};
  margin-top: ${props => props.noTopMargin ? 0 : props.theme.margin};
  font-family: ${p => p.theme.button.checkout.fontFamily};
  font-size: ${p => p.theme.button.checkout.fontSize};
  font-weight: ${p => p.theme.button.checkout.fontWeight};
  padding: ${p => p.theme.button.checkout.padding};
  margin: ${p => p.theme.button.checkout.margin};
  color: ${p => p.theme.button.checkout.color.desktop};
  border: ${p => p.theme.button.checkout.border};
  border-bottom: ${p => p.theme.button.checkout.borderBottom};
  width: ${p => p.theme.button.checkout.width};
  &:hover {
    background-color: ${props => props.theme.button.hoverColor};
    color: ${props => props.theme.button.primary.hoverTextColor};
  }
  &:disabled {
    cursor: default;
    background-color: ${p => p.theme.button.checkout.disabled.backgroundColor};
    color: ${p => p.theme.button.checkout.disabled.color};
    border-bottom: ${p => p.theme.button.checkout.disabled.borderBottom};
    border-color: ${p => p.theme.button.checkout.disabled.borderColor};
  }

  ${media.small`
    background-color: ${p => p.isLoading ? p.theme.button.checkout.disabled.backgroundColor : p.theme.button.checkout.backgroundColor.mobile};
    color: ${p => p.theme.button.checkout.color.mobile};
    width: 14rem;
    font-size: 1.4rem;
    border-radius: 0;
    height: 4.8rem;
    box-shadow: -0.2rem 0.2rem 0.2rem rgba(0, 0, 0, 0.75);
    margin-top: 0;
  `};
`;

export const CheckoutButtonSubTitle = styled.div`
  font-size: ${p => p.theme.button.checkout.subTitle.fontSize};
  ${media.small`
    font-size: 1rem;
    display: none;
  `};
`;

export const CheckoutButtonText = styled.span`
  width: 100%;
`;

export const PaymentIconsWrapper = styled.div`
  padding-top: ${props => props.theme.padding};
  display: ${props => props.showPaymentIcons ? 'block' : 'none'};
  ${media.small`
    display: none;
  `};
`;

export const LoadingStyled = styled.div`
  position: absolute;
  bottom: 0.1rem;
  width: 100%;
`;

export const Content = styled.div`
  height: inherit;
  border-bottom: ${p => p.theme.sideBasket.summary.borderRight};
  max-height: 100vh;
  overflow-y: auto;
  ${media.small`
    border-bottom: 0;
  `};
`;

export const Summary = styled.div`
  background-color: ${p => p.theme.sideBasket.summary.backgroundColor};
  padding: ${p => p.theme.sideBasket.summary.padding};
  border-right: ${p => p.theme.sideBasket.summary.borderRight};
  ${media.small`
    background-color: ${props => props.theme.sideBasket.backgroundColor};
    position: ${props => props.expand ? 'fixed' : 'relative'};
    bottom: ${props => props.expand ? 0 : 'initial'};
    width: 100%;
    padding: 0;
    border-right: 0;
    transform: translate3d(0px, 0px, 0px);
  `};
`;

export const LeftPanel = styled.div`
  ${media.small`
    display: flex;
    justify-content: space-between;
    padding-left: ${props => props.theme.padding};
    width: ${props => props.isMenuPage ? 'auto' : '100%'};
  `};
`;

export const SummaryContent = styled.div`
  position: relative;
  text-align: center;
  ${media.small`
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    flex-direction: ${props => props.restaurantClosed ? 'column' : 'row'};
  `};
`;

export const RestaurantClosed = styled.div`
  background-color: ${props => props.theme.sideBasket.closedBackground};
  text-align: center;
  padding: 0.4rem;
`;

export const RestaurantClosedTitle = styled.h3`
  color: ${props => props.theme.primaryColor};
  margin: 0.4rem;
`;

export const RestaurantClosedText = styled.p`
  color: ${props => props.theme.primaryColor};
  margin: 0.4rem;
  font-size: 1.4rem;
  a {
    color: ${props => props.theme.primaryColor};
    text-decoration: underline;
  }
`;

export const CheckYourOrderMessageStyled = styled.div`
  color: ${props => props.theme.sideBasket.message};
  margin-top: ${props => props.theme.margin};
  padding: ${props => props.theme.sideBasket.summary.message.padding};
  font-size: ${props => props.theme.sideBasket.summary.message.fontSize};
  text-align: center;
  ${media.small`
    display: none;
  `};
`;

export const ChangeOrder = styled.div`
  font-size: ${props => props.theme.sideBasket.option.fontSize};
  padding: ${props => props.theme.padding};
  border-top-color: ${props => props.theme.borderColor};
  border-top-width: ${props => props.theme.borderWidth};
  border-top-style: solid;
  ${media.small`
    border: none;
    flex-grow: 2;
    text-align: right;
    font-weight: bold;
  `};
  a {
    color: ${props => props.theme.tertiaryColor};
  }
`;

export const DineInStatus = styled.div`
  padding: 1rem;
  ${media.small`
    display: flex;
    padding: 0.5rem 1rem;
    border-top: solid 1px ${props => props.theme.borderColorRevert};
  `};
`;

export const DineInOrderText = styled.div`
  display: flex;
  color: ${props => props.theme.quaternaryColor};
  font-size: ${props => props.theme.sideBasket.dineIn.message.fontSize};
  font-weight: bold;
  ${media.small`
    flex-grow: 1;
    align-items: center;
    padding: ${props => props.theme.sideBasket.dineIn.padding.mobile};
    color: ${props => props.theme.primaryColor};
  `};
`;

export const NotDineIn = styled.div`
  color: ${p => p.theme.secondaryColor};
  cursor: pointer;
  display: flex;
  font-size: ${p => p.theme.sideBasket.dineIn.link.fontSize};
  ${media.small`
    color: ${p => p.theme.sideBasket.dineIn.link.color};
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    font-size: 1.3rem;
    line-height: 1.6rem;
  `};
`;

export const NotDineInLink = styled.a`
  text-decoration: underline;
  padding-left: 0.6rem;
`;



// WEBPACK FOOTER //
// ./components/SideBasket/SideBasket.style.js